import styled, { css } from 'styled-components';

const ChatOverlayContainer = styled.div`
	bottom: 0;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 20000;
	pointer-events: none;
	overflow: hidden;

	&.chat-overlay-mobile--hover > div, &.chat-overlay-mobile--hover > button {
		transition: bottom 0.2s linear;
	}

	${({ hideRightControls }) =>
		hideRightControls &&
		css`
			visibility: hidden;
		`}
`;

const ChatOverlayWrapper = styled.div`
	height: 100%;
	width: 100%;
	bottom: ${({ isMobile }) => (isMobile ? '0' : '60px')};
	transition: bottom 0.2s linear;
	position: absolute;
	z-index: 2;
	display: flex;
	flex-direction: row;
	pointer-events: none;
	justify-content: space-between;

	${({ chatVisible }) =>
		!chatVisible &&
		css`
			visibility: hidden;
		`}

	${({ chatVisible, showMobileChat }) =>
		chatVisible &&
		!showMobileChat &&
		css`
			pointer-events: none !important;
			background: transparent !important;
		`}
`;

const ChatWrapper = styled.div`
	width: 85%;
	display: flex;
	flex-direction: column-reverse;
	pointer-events: none;
	position: relative;

	${({ showMobileChat }) =>
		!showMobileChat &&
		css`
			visibility: hidden;
		`}

	@media screen and (max-width: 992px) and (orientation: landscape) and (hover: none) and (pointer: coarse) {
		width: 30%;
		pointer-events: none;
	}
`;

export { ChatOverlayContainer, ChatOverlayWrapper, ChatWrapper };
